import {gql} from "graphql-tag";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const privacyPolicyTermsConditionFields = `
id
uniqueId
content
`;


export const CREATE_TERMS_CONDITION_MUTATION = gql`
mutation CreateTermAndConditionMutation($input: TermAndConditionInputObject!) {
  createTermAndConditionMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${privacyPolicyTermsConditionFields}
    }
  }
}
`


export const UPDATE_TERMS_CONDITION_MUTATION = gql`
mutation UpdateTermAndConditionMutation($input: TermAndConditionInputObject!) {
  updateTermAndConditionMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${privacyPolicyTermsConditionFields}
    }
  }
}
`


export const DELETE_TERMS_CONDITION_MUTATION = gql`
mutation DeleteTermAndConditionMutation($uniqueId: String!) {
  deleteTermAndConditionMutation(uniqueId: $uniqueId) {
    ${baseResponseGraphqlField}
  }
}
`


export const GET_TERMS_CONDITION = gql`
query GetTermsAndConditions($filtering: TermAndConditionFilteringInputObject) {
  getTermsAndConditions(filtering: $filtering) {
    ${baseResponseGraphqlField}
    data {
      ${privacyPolicyTermsConditionFields}
    }
  }
}
`


export const CREATE_PRIVACY_POLICY_MUTATION = gql`
mutation CreatePrivacyAndPolicyMutation($input: PrivacyAndPolicyInputObject!) {
  createPrivacyAndPolicyMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${privacyPolicyTermsConditionFields}
    }
  }
}
`


export const UPDATE_PRIVACY_POLICY_MUTATION = gql`
mutation UpdatePrivacyAndPolicyMutation($input: PrivacyAndPolicyInputObject!) {
  updatePrivacyAndPolicyMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${privacyPolicyTermsConditionFields}
    }
  }
}
`


export const DELETE_PRIVACY_POLICY_MUTATION = gql`
mutation DeletePrivacyAndPolicyMutation($uniqueId: String!) {
  deletePrivacyAndPolicyMutation(uniqueId: $uniqueId) {
    ${baseResponseGraphqlField}
  }
}
`


export const GET_PRIVACY_POLICY = gql`
query GetPrivacyAndPolicy($filtering: PrivacyAndPolicyFilteringInputObject) {
  getPrivacyAndPolicy(filtering: $filtering) {
    ${baseResponseGraphqlField}
    data {
      ${privacyPolicyTermsConditionFields}
    }
  }
}
`
